import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "diensten", label: "Diensten" },
  { id: "voor-na", label: "Voor & Na" },
  { id: "werkwijze", label: "Werkwijze" },
  { id: "reviews", label: "Reviews" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-black"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-24 md:h-28 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src="/brand/logo.png"
            alt="MasterBathrooms"
            className="h-20 md:h-28 w-auto"
          />
        </button>

        <ul className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-xs uppercase tracking-[0.18em] font-semibold text-white hover:text-[#3D7AE0] transition-colors"
              >
                {l.label}
              </button>
            </li>
          ))}
          <li>
            <button
              data-testid="nav-cta"
              onClick={() => go("contact")}
              className="btn-primary-mb px-5 py-3 text-xs"
            >
              Gratis advies
            </button>
          </li>
        </ul>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-black border-t border-white/10"
        >
          <ul className="flex flex-col px-5 py-4">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="w-full text-left py-3 text-sm uppercase tracking-[0.16em] text-white"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li className="pt-2">
              <button
                data-testid="nav-mobile-cta"
                onClick={() => go("contact")}
                className="btn-primary-mb w-full px-5 py-3 text-xs"
              >
                Gratis adviesgesprek
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
